import { useState } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import SelectSymbol from '../../components/SelectSymbol';
import MyStrategies from './MyStrategies/MyStrategies';
import SharedStrategies from './SharedStrategies/SharedStrategies';
import StrategyRecommendationModal from './StrategyRecommendationModal';
import StrategyWizard from './StrategyWizard';
import './Strategies.css';

function Strategies() {

    const [symbol, setSymbol] = useState('');

    const [notification, setNotification] = useState({ type: '', text: '' });

    function onSymbolChange(event) {
        setSymbol(event.target.value);
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Minhas Estratégias</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="d-inline-flex align-items-center">
                            <div className="me-2">
                                <SelectSymbol symbol={symbol} disabled={false} onChange={onSymbolChange} showAny={false} onlyFavorites={false} />
                            </div>
                            <button 
                                className="btn me-2" 
                                data-bs-toggle="modal" 
                                data-bs-target="#modalStrategyRecommendation"
                                style={{ backgroundColor: '#FFD700', borderColor: '#FFD700', color: '#000' }}
                            >
                                <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 1114.32 4.906l1.387 1.387a1 1 0 01-1.414 1.414l-1.387-1.387A8 8 0 012 10zm8-5a5 5 0 100 10A5 5 0 0010 5z" /></svg>
                                IA sugerir estratégia
                            </button>
                            <button className="btn btn-success me-2" data-bs-toggle="modal" data-bs-target="#modalStrategyWizard">
                                <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" /></svg>
                                Criar Estratégia Completa
                            </button>
                            <button id="btnNewStrategy" className="btn btn-primary animate-up-2" data-bs-toggle="modal" data-bs-target="#modalStrategy">
                                <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" /></svg>
                                Nova Estratégia
                            </button>
                        </div>
                    </div>
                </div>
                <MyStrategies symbol={symbol} onNotification={setNotification} />
                <SharedStrategies symbol={symbol} onNotification={setNotification} />
                <Footer />
            </main>
            <StrategyRecommendationModal symbol={symbol} onNotification={setNotification} />
            <StrategyWizard onNotification={setNotification} />
            <Toast type={notification.type} text={notification.text} />
        </>
    );
}

export default Strategies;
